var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-16"},[_c('p',{staticClass:"text-h5 text-center white--text"},[_vm._v("Paypayからの入金を確認中です")]),_c('p',{staticClass:"text-subtitle-1 text-center white--text"},[_vm._v("自動で遷移するまでお待ち下さい")])])
}
var staticRenderFns = []

export { render, staticRenderFns }